import styles from './LoginErrorBox.module.scss'

const LoginErrorBox = ({ title, description }) => (
  <div className={styles.loginErrorBox}>
    <p className={styles.loginErrorBoxTitle}>{title}</p>
    <p className={styles.loginErrorBoxBody}>{description}</p>
  </div>
)

export default LoginErrorBox
